import React, { useState } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles, Avatar } from '@material-ui/core';
import parseImagUrl from "../../../../components/Common/parseImagUrl";
import { goToCollection } from "../../../../../actions/goToActions";
import GeneralButton from '../../../../components/Common/AllButton/AllButton';
import { allCollectionMembers, isUserMember } from '../../../groups/groupUtils';
import groupPlaceholder from "../../../../../assets/img/group_placeholder.png";
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: 10,
        marginRight: 10,
        width: 423,
        maxWidth: 423,
        minWidth: 423,
        height: 236,
        backgroundColor: '#fff',
        position: 'relative',
        borderRadius: 4,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        '&:last-child': {
            marginRight: 0
        },
        '&:nth-child(3)': {
            marginRight: 0
        },  
    },
    img: {
        objectFit: 'cover',
        width: 160,
        height: 236,
    },
    content: {
        flexDirection: 'column',
        paddingLeft: 16,
        paddingRight: 16
    },
    title: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: '21212d'
        },
        marginTop: 24,
        fontFamily: 'Rubik',
        fontSize: 18,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#21212d',
    },
    subtitle: {
        height: 60,
        marginTop: 8,
        fontFamily: 'Rubik',
        fontSize: 14,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#a3a3a3',
    },
    followers: {
        marginTop: 8,
        marginLeft: 8,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    subsribe: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start'
    },
    subsribeButtomContainer: {
        width: 130,
        height: 38,
        marginLeft: 0,
        backgroundColor: 'transparent',
        border: 'solid 2px #21212d',
        color: '#21212d',
        '&:hover': {
            background: '#21212d',
            color: '#fff',
        },
    },
    subsribeButtomText: {
        marginTop: 2,
        fontSize: 14,
        lineHeight: 2,
        letterSpacing: 1.5,
    },
    unsubsribeButtomContainer: {
        marginLeft: 0,
        width: 130,
        height: 38,
        backgroundColor: '#21212d',
        border: 'solid 2px #21212d',
        color: '#fff',
        '&:hover': {
            background: 'transparent',
            color: '#21212d',
        },
    },
    avatar: {
        border: 'solid 2px #fff',
        width: 24,
        height: 24,
        marginLeft: -12
    },
    moreAvatars: {
        border: 'solid 2px #fff',
        marginLeft: 0,
        height: 24,
        background: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        color: '#23232f',
        fontWeight: 'normal',
        fontSize: 12,
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        lineHeight: 1.33,
        fontStretch: 'normal',
        letterSpacing: 'normal',
    },
    collectionFaces: { display: 'flex' }
});



const KanbanGroup = (props) => {
    const {classes, kanbanGroup, cloudfront, dispatch, profileData, join, t} = props
    const [backgroundLink] = useState(parseImagUrl(cloudfront, kanbanGroup.backgroundImage, 500, groupPlaceholder))
    const canLeaveTheGroup = isUserMember(allCollectionMembers(kanbanGroup.meta), profileData.auth0_id)

    const openCollectionView = () => {
        goToCollection('/' + kanbanGroup.title, dispatch, kanbanGroup.collectionUid, kanbanGroup.groupUid)();
    }
    const renderCollectionFaces = () => {
        const members = kanbanGroup.followers
        return <div data-intrcm-id="KanbanGroup_9serlrs9" className={classes.collectionFaces}>
            {members.slice(0, 3).map((tagedUser, idx) => {
                return <Avatar key={idx} alt={tagedUser.fullName} src={parseImagUrl(cloudfront, tagedUser.profileImageUrl)} className={classes.avatar} />
            })}
            {members.length - 3 > 0 && <div data-intrcm-id="KanbanGroup_xlm69674" className={classes.moreAvatars}>{`+${members.length - 3} ${t('Subscribers')}`}</div>}
        </div>
    }
    const onClickGeneral = () => {
        canLeaveTheGroup ? openCollectionView() : join(kanbanGroup.groupUid, openCollectionView)
    }
    const renderSubscribeButton = () => {
        const title = canLeaveTheGroup ? t('VIEW') : t('JOIN')
        const containerStyle = canLeaveTheGroup ? classes.unsubsribeButtomContainer : classes.subsribeButtomContainer
        return <GeneralButton onClick={onClickGeneral} containerStyle={containerStyle} textStyle={classes.subsribeButtomText} title={title} />
    }

        return (
            <div data-intrcm-id="KanbanGroup_zsk76yse" className={classes.container}>
                <div data-intrcm-id="KanbanGroup_nrvueyqh" style={{flexDirection: 'column'}} >
                    <img alt="img" src={backgroundLink} className={classes.img} />
                </div>
                <div data-intrcm-id="KanbanGroup_ts1r5b39" className={classes.content}>
                    <div data-intrcm-id="KanbanGroup_xwvahl5k" onClick={openCollectionView} className={classes.title}>{kanbanGroup.title}</div>
                    <div data-intrcm-id="KanbanGroup_e0x13pwh" className={classes.subtitle}>{kanbanGroup.subtitle}</div>
                    <div data-intrcm-id="KanbanGroup_3yn1t9gu" className={classes.followers}>
                        {renderCollectionFaces()}
                    </div>
                    <div data-intrcm-id="KanbanGroup_08jxsvc5" className={classes.subsribe}>
                        {renderSubscribeButton()}
                    </div>
                </div>
          </div>
        )
}

const mapStateToProps = (state) => ({
    cloudfront: state.globalData.cloudfront,
    profileData: state.userData.profileData
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    withTranslation('groupDrawerTranslate'),
    connect(mapStateToProps, mapDispatchToProps))(KanbanGroup);
